import {
    CameraWithInfo,
    GeoZones,
    GeoZoneValidationType,
    Solar4gCaptureInfo,
    Solar4gCellularInfo,
    Solar4gCellularStatus,
} from '@EcamModel/model';
import { CameraNotes } from '@EcamModel/model/CameraNotes';
import { CameraTask } from '@EcamModel/model/CameraTask';
import {
    CameraTrailAuditEventEntityName,
    CameraTrailAuditEventType,
    GeoZoneAuditEvent,
} from '@EcamModel/model/CameraTrailAudit';
import { PTZCamera } from '@EcamModel/model/PTZCamera';
import { PTZPresets } from '@EcamModel/model/PTZPresets';
import { BaseSelect } from '@pages/cameras/list';

export const eventLogType: Record<CameraTrailAuditEventType, string> = {
    [CameraTrailAuditEventType.CREATE]: 'Created',
    [CameraTrailAuditEventType.DELETE]: 'Deleted',
    [CameraTrailAuditEventType.UPDATE]: 'Updated',
    [CameraTrailAuditEventType.OTHER]: 'Other',
    [CameraTrailAuditEventType.RETRIEVE]: 'Retrieved',
};

export type AllTypesCameraTrailAuditEntity = Partial<
    CameraWithInfo &
        GeoZoneAuditEvent &
        CameraTask &
        CameraNotes &
        PTZCamera &
        Solar4gCellularStatus &
        Solar4gCellularInfo &
        Solar4gCaptureInfo  & PTZPresets & GeoZones
>;

export const detectModesMapping: Record<GeoZoneValidationType, string> = {
    [GeoZoneValidationType.Center]: 'Center',
    [GeoZoneValidationType.Contained]: 'Contained',
    [GeoZoneValidationType.Covered]: 'Covered',
};

export const keyCameraTrailAuditEntity: { [key in keyof AllTypesCameraTrailAuditEntity]: string } = {
    // Camera details
    Name: 'Camera name',
    Mac: 'Mac',
    Asset: 'Asset',
    LensCapacity: 'Len caps',
    PurposeType: 'Purpose',
    SolarPanelPosition: 'Solar Panel Position',
    Status: 'Status',
    Notes: 'Notes',
    PowerSupply: 'Power supply',
    ExemptVehicleTypes: 'Exempt vehicle types',

    // Camera task
    TaskName: 'Task Name',
    TaskPriority: 'Priority',
    TaskStatus: 'Status',
    Assignee: 'Assignee',
    Problem: 'Problem',
    Solution: 'Solution',
    TaskType: 'Task Type',
    SubTask: 'Sub task',
    Note: 'Note',
    EndDate: 'Due Date',

    // Services
    ANPRCameraId: 'ANPR ID',
    ServiceType: 'Service',

    // Account
    IP: 'IP',
    UserName: 'Username',
    PassWord: 'Password',

    // Geo-zones
    EffectiveFrom: 'Effective from',
    ContraventionType: 'Contravention type',
    ValidationType: 'Validation type',
    PermitExemptionsEnabled: 'Permit exceptions',
    GeoZoneCoordinates: 'Coordinates',
    GZOConfigs: 'Geo-zone configs',
    GeoZoneName: 'Geo-zone name',
    TotalBay: 'Total bay',
    PostCaptureNumber: 'Extra night shot',

    // Allocated zone
    LocationName: 'Location',
    ZoneName: 'Zone',
    TimeZone: 'Time zone',

    // Data processing
    EnablePcnVerificationAt: 'Enable verifications at',
    IsVerificationsEnabled: 'Enable verifications',
    EnableGroupMatchingAt: 'Enable group matching at',

    // EV permit exemption
    IsSendEVPermitEnabled: 'EV permit exemption',
    EvPermitLengthSeconds: 'EV permit length',
    EvPermitZoneNames: 'EV permit zones',

    // Production
    DeployedDate: 'Production',

    // PTZ camera
    PatrolMode: 'Patrol mode',

    // 4G Cellular Status
    Isp: 'ISP',
    ConnectStatus: 'Connection status',
    SimStatus: 'SIM status',
    SignalStrength: 'Signal strength',
    Imei: 'IMEI',
    Imsi: 'IMSI',
    Iccid: 'ICCID',
    IpAddr: 'IP address',
    SubMask: 'Subnet mask',
    Gateway: 'Gateway',
    Dns: 'DNS',
    DataMonthly: 'Monthly data',

    // 4G Cellular Info
    Apn: 'APN',
    Password: 'Password',

     // 4G Capture Info
    SnapshotTopic: 'Snapshot topic',
    StatusTopic: 'Status topic',
    AlarmTopic: 'Alarm topic',
    ConfigTopic: 'Configure request topic',
    ConfigRespTopic: 'Configure respond topic',
    PresetName: 'Preset name',
    PtzPanPos: 'Pan',
    PtzTiltPos: 'Tilt',
    PtzZoomPos: 'Zoom',
};

export interface Section {
    label: string;
    keys: string[];
    condition?: boolean;
}

export interface checkValues {
    key: string;
    oldValue: string;
    newValue: string;
}

export const entityNameOptions: BaseSelect[] = [
    { Id: 1, Name: 'Camera', Value: CameraTrailAuditEventEntityName.camera },
    { Id: 2, Name: 'Geo zones', Value: CameraTrailAuditEventEntityName.geoZones },
    { Id: 3, Name: 'Verification notes', Value: CameraTrailAuditEventEntityName.notes },
    { Id: 4, Name: 'Camera notes', Value: CameraTrailAuditEventEntityName.cameraNotes },
    { Id: 5, Name: 'Task', Value: CameraTrailAuditEventEntityName.cameraTask },
    { Id: 6, Name: 'PTZ presets', Value: CameraTrailAuditEventEntityName.ptzPreset },
];

export const typeEventLog: BaseSelect[] = [
    {
        Id: 1,
        Name: 'Created',
        Value: CameraTrailAuditEventType.CREATE,
    },
    {
        Id: 2,
        Name: 'Deleted',
        Value: CameraTrailAuditEventType.DELETE,
    },
    {
        Id: 3,
        Name: 'Updated',
        Value: CameraTrailAuditEventType.UPDATE,
    },
    {
        Id: 4,
        Name: 'Other',
        Value: CameraTrailAuditEventType.OTHER,
    },
    {
        Id: 5,
        Name: 'Retrieved',
        Value: CameraTrailAuditEventType.RETRIEVE,
    },
];
